export function Card({ children, className = '', tone = '' }) {
  return <article className={`card ${tone ? `card-${tone}` : ''} ${className}`}>{children}</article>;
}

export function Score({ value }) {
  return <span className="score">{value}%</span>;
}
